// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"25febf2d","420":"9eb6cf78","810":"a0f72066"}[chunkId] + ".chunk.css";
};